import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.assign";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import "core-js/modules/es6.array.map";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { each, createInterpolator, is, toArray, Globals, useForceUpdate, useOnce } from '@react-spring/shared';
import _extends from '@babel/runtime/helpers/esm/extends';
import { createAnimatedTransform, createAnimatedInterpolation, now, createAnimatedStyle, applyAnimatedValues, getComponentProps } from '@react-spring/shared/globals';
export { createAnimatedInterpolation as to } from '@react-spring/shared/globals';
import { deprecateInterpolate } from '@react-spring/shared/deprecations';
import invariant from 'tiny-invariant';
import React, { forwardRef, useRef, useEffect } from 'react';

var _a;

var animatedTag = Symbol["for"]('isAnimated');

var isAnimated = function isAnimated(val) {
  return !!(val && val[animatedTag]);
};

var Animated = /*#__PURE__*/function () {
  function Animated() {
    _classCallCheck(this, Animated);

    this[_a] = true;
    this.children = new Set();
  }
  /** Returns the set of `AnimatedValue` nodes contained by this node. */


  _createClass(Animated, [{
    key: "getPayload",
    value: function getPayload() {
      return this.payload;
    }
    /** Returns the set of animated nodes that depend on this node. */

  }, {
    key: "getChildren",
    value: function getChildren() {
      return this.children;
    }
  }, {
    key: "addChild",
    value: function addChild(child) {
      this.children.size || this._attach();
      this.children.add(child);
    }
  }, {
    key: "removeChild",
    value: function removeChild(child) {
      this.children["delete"](child);
      this.children.size || this._detach();
    }
  }]);

  return Animated;
}();

_a = animatedTag;

var AnimatedObject = /*#__PURE__*/function (_Animated) {
  _inherits(AnimatedObject, _Animated);

  var _super = _createSuper(AnimatedObject);

  function AnimatedObject(source) {
    var _this;

    _classCallCheck(this, AnimatedObject);

    _this = _super.call(this);
    _this.source = source;
    _this.payload = toPayload(source);
    return _this;
  }

  _createClass(AnimatedObject, [{
    key: "getValue",
    value: function getValue(animated) {
      var obj = {};
      each(this.source, function (val, key) {
        if (isAnimated(val)) {
          obj[key] = val.getValue(animated);
        } else if (!animated) {
          obj[key] = val;
        }
      });
      return obj;
    }
  }, {
    key: "updatePayload",
    value: function updatePayload(prev, next) {
      var source = _extends({}, this.source);

      each(source, function (val, key) {
        if (val === prev) source[key] = next;
      });
      this.source = source;
      this.payload = toPayload(source);
    }
  }, {
    key: "_attach",
    value: function _attach() {
      each(this.source, addChild, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      each(this.source, removeChild, this);
    }
  }]);

  return AnimatedObject;
}(Animated);
/** Convert an array or object to a flat payload */


function toPayload(source) {
  var payload = new Set();
  each(source, function (val) {
    if (isAnimated(val)) {
      each(val.getPayload(), function (node) {
        return payload.add(node);
      });
    }
  });
  return payload;
}

function addChild(parent) {
  if (isAnimated(parent)) parent.addChild(this);
}

function removeChild(parent) {
  if (isAnimated(parent)) parent.removeChild(this);
}

var AnimatedStyle = /*#__PURE__*/function (_AnimatedObject) {
  _inherits(AnimatedStyle, _AnimatedObject);

  var _super2 = _createSuper(AnimatedStyle);

  function AnimatedStyle(style) {
    _classCallCheck(this, AnimatedStyle);

    if (style === void 0) {
      style = {};
    }

    return _super2.call(this, style.transform && createAnimatedTransform ? _extends({}, style, {
      transform: createAnimatedTransform(style.transform)
    }) : style);
  }

  return AnimatedStyle;
}(AnimatedObject);

var AnimatedInterpolation = /*#__PURE__*/function (_Animated2) {
  _inherits(AnimatedInterpolation, _Animated2);

  var _super3 = _createSuper(AnimatedInterpolation);

  function AnimatedInterpolation(source, args) {
    var _this2;

    _classCallCheck(this, AnimatedInterpolation);

    _this2 = _super3.call(this);
    _this2.source = source;
    _this2.calc = createInterpolator.apply(void 0, _toConsumableArray(args));
    return _this2;
  }

  _createClass(AnimatedInterpolation, [{
    key: "getValue",
    value: function getValue(animated) {
      var args = is.arr(this.source) ? this.source.map(function (node) {
        return node.getValue(animated);
      }) : toArray(this.source.getValue(animated));
      return this.calc.apply(this, _toConsumableArray(args));
    }
  }, {
    key: "to",
    value: function to() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return new AnimatedInterpolation(this, args);
    }
  }, {
    key: "interpolate",
    value: function interpolate() {
      deprecateInterpolate();
      return this.to.apply(this, arguments);
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      return is.arr(this.source) ? this.payload || (this.payload = toPayload(this.source)) : this.source.getPayload();
    }
  }, {
    key: "updatePayload",
    value: function updatePayload(prev, next) {
      this.payload = void 0;

      if (is.arr(this.source)) {
        var source = _toConsumableArray(this.source);

        each(source, function (val, index) {
          if (val === prev) source[index] = next;
        });
        this.source = source;
      } else {
        this.source = next;
      }
    }
  }, {
    key: "_attach",
    value: function _attach() {
      each(toArray(this.source), addChild, this);
    }
  }, {
    key: "_detach",
    value: function _detach() {
      each(toArray(this.source), removeChild, this);
    }
  }]);

  return AnimatedInterpolation;
}(Animated);

Globals.assign({
  createAnimatedStyle: function createAnimatedStyle(style) {
    return new AnimatedStyle(style);
  },
  createAnimatedInterpolation: function createAnimatedInterpolation(parents) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return new AnimatedInterpolation(parents, args);
  }
});

var interpolate = function interpolate() {
  deprecateInterpolate();
  return createAnimatedInterpolation.apply(void 0, arguments);
};
/** An animated number or a native attribute value */


var AnimatedValue = /*#__PURE__*/function (_Animated3) {
  _inherits(AnimatedValue, _Animated3);

  var _super4 = _createSuper(AnimatedValue);

  function AnimatedValue(value) {
    var _this3;

    _classCallCheck(this, AnimatedValue);

    _this3 = _super4.call(this);
    _this3.views = new Set();
    _this3.done = false;
    _this3.value = value;
    _this3.payload = new Set([_assertThisInitialized(_this3)]);

    if (is.num(value)) {
      _this3.startPosition = value;
      _this3.lastPosition = value;
    }

    return _this3;
  }

  _createClass(AnimatedValue, [{
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "setValue",
    value: function setValue(value, flush) {
      this.value = value;

      if (flush !== false) {
        if (!this.views.size) {
          collectViews(this, this.views);
        }

        each(this.views, function (view) {
          return view.update();
        });
      }
    }
  }, {
    key: "to",
    value: function to() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return createAnimatedInterpolation.apply(void 0, [this].concat(args));
    }
  }, {
    key: "interpolate",
    value: function interpolate() {
      deprecateInterpolate();
      return this.to.apply(this, arguments);
    }
  }, {
    key: "reset",
    value: function reset(isActive) {
      if (is.num(this.value)) {
        this.startPosition = this.value;
        this.lastPosition = this.value;
        this.lastVelocity = isActive ? this.lastVelocity : undefined;
        this.lastTime = isActive ? this.lastTime : undefined;
        this.startTime = now();
      }

      this.done = false;
      this.views.clear();
    } // Do nothing for either of these.

  }, {
    key: "_attach",
    value: function _attach() {}
  }, {
    key: "_detach",
    value: function _detach() {}
  }]);

  return AnimatedValue;
}(Animated);
/**
 * This library works by building a directed acyclic graph of dependencies
 * transparently whenever you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an AnimatedValue is updated, we recursively go down through this
 * graph in order to find leaf nodes: the components that depend on our value.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new props that it needs. This two-phase process is
 * necessary because some props (eg: "transform") can have multiple parents.
 */


function collectViews(node, views) {
  if ('update' in node) {
    views.add(node);
  } else {
    each(node.getChildren(), function (child) {
      return collectViews(child, views);
    });
  }
}
/** An array of animated nodes */


var AnimatedArray = /*#__PURE__*/function (_AnimatedObject2) {
  _inherits(AnimatedArray, _AnimatedObject2);

  var _super5 = _createSuper(AnimatedArray);

  function AnimatedArray(source) {
    _classCallCheck(this, AnimatedArray);

    return _super5.call(this, source);
  }

  _createClass(AnimatedArray, [{
    key: "getValue",
    value: function getValue(animated) {
      return this.source.map(function (node) {
        return node.getValue(animated);
      });
    }
  }, {
    key: "setValue",
    value: function setValue(value, flush) {
      var nodes = this.payload;

      if (is.arr(value)) {
        invariant(value.length == nodes.size);
        var i = 0;
        each(nodes, function (node) {
          return node.setValue(value[i++], flush);
        });
      } else {
        each(nodes, function (node) {
          return node.setValue(value, flush);
        });
      }
    }
  }, {
    key: "to",
    value: function to() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return createAnimatedInterpolation.apply(void 0, [this].concat(args));
    }
  }, {
    key: "interpolate",
    value: function interpolate() {
      deprecateInterpolate();
      return this.to.apply(this, arguments);
    }
  }, {
    key: "updatePayload",
    value: function updatePayload(prev, next) {
      var source = _toConsumableArray(this.source);

      each(source, function (val, index) {
        if (val === prev) source[index] = next;
      });
      this.source = source;
      this.payload = toPayload(source);
    }
  }]);

  return AnimatedArray;
}(AnimatedObject);

var AnimatedProps = /*#__PURE__*/function (_AnimatedObject3) {
  _inherits(AnimatedProps, _AnimatedObject3);

  var _super6 = _createSuper(AnimatedProps);

  function AnimatedProps(props, update) {
    var _this4;

    _classCallCheck(this, AnimatedProps);

    _this4 = _super6.call(this, props.style && createAnimatedStyle ? _extends({}, props, {
      style: createAnimatedStyle(props.style)
    }) : props);
    _this4.update = update;
    return _this4;
  }

  return AnimatedProps;
}(AnimatedObject);

var cacheKey = Symbol["for"]('AnimatedComponent');

var withAnimated = function withAnimated(Component) {
  return is.str(Component) ? createAnimatedComponent(Component) : Component[cacheKey] || (Component[cacheKey] = createAnimatedComponent(Component));
};

var createAnimatedComponent = function createAnimatedComponent(Component) {
  return forwardRef(function (rawProps, ref) {
    var node = useRef(null);
    var props = useRef(null);
    var forceUpdate = useForceUpdate();
    var nextProps = new AnimatedProps(rawProps, function () {
      if (!node.current) return;
      var didUpdate = applyAnimatedValues(node.current, nextProps.getValue(true)); // Re-render the component when native updates fail.

      if (didUpdate === false) {
        forceUpdate();
      }
    });
    useEffect(function () {
      var prevProps = props.current;
      props.current = nextProps; // To avoid causing a cascade of detachment, we must detach
      // the old props only *after* the new props are attached.

      nextProps._attach();

      if (prevProps) {
        prevProps._detach();
      }
    }); // Ensure the latest props are detached on unmount.

    useOnce(function () {
      return function () {
        props.current._detach();
      };
    }); // Functions cannot have refs (see #569)

    var refFn = !is.fun(Component) || Component.prototype.isReactComponent ? function (value) {
      return node.current = updateRef(ref, value);
    } : void 0;
    rawProps = getComponentProps(nextProps.getValue());
    return React.createElement(Component, Object.assign({}, rawProps, {
      ref: refFn
    }));
  });
};

function updateRef(ref, value) {
  if (ref) {
    if (is.fun(ref)) ref(value);else ref.current = value;
  }

  return value;
}
/**
 * Pass the given components to `withAnimated` and add the newly animated
 * components to `withAnimated` as properties.
 */


var extendAnimated = function extendAnimated(withAnimated, components, lowercase) {
  components.forEach(function (Component) {
    var key = getDisplayName(Component);

    if (lowercase) {
      key = key[0].toLowerCase() + key.slice(1);
    }

    withAnimated[key] = withAnimated(Component);
  });
  return withAnimated;
};

var getDisplayName = function getDisplayName(arg) {
  return is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;
};

export { Animated, AnimatedArray, AnimatedInterpolation, AnimatedObject, AnimatedProps, AnimatedStyle, AnimatedValue, addChild, animatedTag, extendAnimated, interpolate, isAnimated, removeChild, toPayload, withAnimated };